(function() {
    'use strict';

    angular
        .module('elogbooks.user.contracts')
        .config(registerRoutes);

    function registerRoutes($stateProvider) {
        elbContractsRouting().addRoutes($stateProvider, 'dashboard.user.contracts', true);
    }
})();
